import OGlobalFooter from './index.vue';

OGlobalFooter.install = app => {
  app.component(OGlobalFooter.name, OGlobalFooter);
};

export default OGlobalFooter;
